import {Component} from '@angular/core';

@Component({
    template: '<div>PageNotFoundComponent</div>',
    standalone: false
})
export class PageNotFoundComponent {

}
